import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
} from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  InputNumber,
  Popconfirm,
  notification,
} from 'antd';
import { EditPenIcon } from '../assets/icons/icons';

import greenfeeDealsApi from '../api/greenfeeDeals';
import { useSelector, useDispatch } from 'react-redux';
import { setGolfClubDetails } from '../redux/actions/golfClubActions';
import { DeleteFilled } from '@ant-design/icons';
import { QuestionCircleOutlined } from '@ant-design/icons';

const EditCoursesComponent = forwardRef(({ course, isLast }, ref) => {
  const [isCourseValue, setIsCourseValue] = useState('');
  const [selectedCourse, setSelectedCourse] = useState({});
  const [newRows, setNewRows] = useState([]);
  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = {
    headers: { Authorization: `Bearer ${sessionBnd}` },
  };
  const [inputKey, setInputKey] = useState(0);
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    submitForm() {
      form.submit();
    },
  }));
  const dispatch = useDispatch();
  const { Option } = Select;
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );

  const userDetails = useSelector((state) => state.general.userDetails);
  const userRole = userDetails.role;
  const [isEditingCourses, setIsEditingCourses] = useState(false);
  const formatEuro = (value) => {
    if (value === null || value === undefined || value === '') return ' ';

    const cleaned = String(value).replace(/[ €]/g, '').replace(',', '.');
    if (isNaN(Number(cleaned))) return value + ' ';

    const num = Number(cleaned);
    const rounded = Math.round((num + Number.EPSILON) * 100) / 100;

    let formatted = rounded.toFixed(2).replace('.', ',');

    if (formatted.endsWith(',00')) {
      formatted = formatted.replace(',00', '');
    }

    return formatted;
  };

  const roundValue = (raw) => {
    if (raw === null || raw === undefined || raw === '') return '';

    const cleaned = String(raw).replace(/[ €]/g, '').replace(',', '.');
    if (cleaned === '' || isNaN(Number(cleaned))) return '';

    const parsed = Number(cleaned);
    return Math.round((parsed + Number.EPSILON) * 100) / 100;
  };

  const EuroInput = ({ namePath, tabIndex }) => {
    const inputRef = React.useRef(null);
    const [isTyping, setIsTyping] = useState(false);
    const [localKey, setLocalKey] = useState(0);
    const value = form.getFieldValue(namePath);
    useEffect(() => {
      const timer = setTimeout(() => {
        if (inputRef.current?.input) {
          inputRef.current.input.tabIndex = tabIndex || 0;
        }
      }, 10);

      return () => clearTimeout(timer);
    }, [tabIndex, localKey]);

    return (
      <div style={{ marginBottom: 0, position: 'relative' }}>
        <Form.Item
          name={namePath}
          style={{ marginBottom: 0, position: 'relative' }}
        >
          <InputNumber
            ref={inputRef}
            key={localKey}
            size="small"
            step={0.01}
            parser={(v) =>
              v ? String(v).replace(/[ €]/g, '').replace(',', '.') : ''
            }
            formatter={(v) => {
              if (isTyping) return String(v ?? '');
              return formatEuro(String(v ?? ''));
            }}
            onFocus={() => setIsTyping(true)}
            onBlur={(e) => {
              setIsTyping(false);

              const rounded = roundValue(e.target.value);

              form.setFieldsValue({
                [namePath[0]]: deepSetField(
                  form.getFieldValue(namePath[0]),
                  namePath.slice(1),
                  rounded === '' ? undefined : rounded,
                ),
              });

              setLocalKey((prev) => prev + 1);
            }}
          />
        </Form.Item>
        <span
          style={{
            position: 'absolute',
            right: value ? 15 : 40,
            top: 7,
            color: '#628478',
          }}
        >
          €
        </span>
      </div>
    );
  };

  const deepSetField = (obj, path, value) => {
    if (!obj) obj = {};
    const temp = { ...obj };
    let current = temp;

    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];

      if (current[key] === undefined) {
        current[key] = Number.isInteger(path[i + 1]) ? [] : {};
      }

      current[key] = Array.isArray(current[key])
        ? [...current[key]]
        : { ...current[key] };

      current = current[key];
    }

    current[path[path.length - 1]] = value;
    return temp;
  };

  const addRow = () => {
    setNewRows((prev) => [...prev, { id: Date.now() }]);
  };

  const removeRow = (id) => {
    setNewRows((prev) => prev.filter((row) => row.id !== id));
  };

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();
      await updateCourse(values);
      setIsEditingCourses(false);
    } catch (error) {
      console.log('Validation failed');
    }
  };

  const updateCourse = async (values) => {
    try {
      const update = values.courseValues;

      console.log(update, 'courseValues');

      // Update Details
      const updateDetails = {
        name: update[0].name,
        holes: update[0].holes,
        requirement: update[0].requirement,
      };
      await greenfeeDealsApi.patch(
        `/golfclubs/${golfClubId}/courses/${course[0]._id}`,
        updateDetails,
        headers,
      );

      // Update Pricing
      update.forEach(async (e) => {
        console.log('eeeeeeeeeeeee:::-->>', e);
        let payload = {
          prices: e.standardPricing.prices,
        };

        if (e.standardPricing.name) {
          if (e.standardPricing.name === 'dayfee') {
            payload.dayFee = true;
            payload.numberHoles = null;
          } else {
            payload.numberHoles = e.standardPricing.name;
          }
        }
        await greenfeeDealsApi.patch(
          `/golfclubs/${golfClubId}/standardpricing/${e.standardPricing._id}`,
          payload,
          headers,
        );
      });

      // Insert new Pricing rows
      if (values.newPricing) {
        const rows = Array.isArray(values.newPricing) ? values.newPricing : [];
        for (const newRow of rows) {
          if (newRow?.holes && newRow?.prices?.[0]) {
            let isDayFee = undefined;
            let holes = newRow.holes;
            if (holes === 'dayfee') {
              holes = undefined;
              isDayFee = true;
            }
            await greenfeeDealsApi.post(
              `/golfclubs/${golfClubId}/standardpricing`,
              {
                course: course[0]._id,
                numberHoles: holes,
                prices: newRow.prices,
                dayFee: isDayFee,
              },
              headers,
            );
          }
        }
      }

      // Get Current Values from Server
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      // Update Redux Store
      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Update Successfully',
        description: 'The golf club courses have been updated successfully.',
      });

      const hasNewPricing =
        Array.isArray(values.newPricing) &&
        values.newPricing.some((r) => r?.prices?.[0]);

      if (hasNewPricing) {
        form.resetFields();
        setNewRows([]);
      }
    } catch (error) {
      console.error('Error updating course:', error);
    }
  };

  const deleteStandardPricing = async (id) => {
    await greenfeeDealsApi.delete(
      `/golfclubs/${golfClubId}/standardpricing/${id}`,
      headers,
    );
    const golfClub = await greenfeeDealsApi.post(
      `/golfclubs/golfClubAdmin`,
      { id: golfClubId },
      headers,
    );
    if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
      console.log('Error no Golfclub found for your Admin Account');
      return;
    }
    const results = golfClub.data.data.data;
    dispatch(setGolfClubDetails(results));
  };

  const golfClubId = golfClubDetails._id.golfClub;

  useEffect(() => {
    form.resetFields();
  }, [course]);

  const cancel = (e) => {
    console.log(e);
  };

  const handleChangeCourseValue = (e, pricing) => {
    setIsCourseValue(pricing?.standardPricing._id);
    console.log(pricing);
  };

  const handleMouseLeave = () => setIsCourseValue();

  const handleSelectChange = (value, index) => {
    setSelectedCourse((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  const TAB_COLUMNS = 7;

  const getTabIndex = (rowIndex, colIndex) => {
    return rowIndex * TAB_COLUMNS + colIndex + 1;
  };

  const newPricingStartIndex = course.length * TAB_COLUMNS + 1;

  // Reusable + button
  const PlusButton = () => (
    <Button
      size="small"
      onClick={addRow}
      style={{
        borderRadius: 8,
        color: '#628478',
        backgroundColor: '#F4F8F7',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.70837 6.5H10.2917"
          stroke="#628478"
          strokeWidth="1.08333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 2.70831V10.2916"
          stroke="#628478"
          strokeWidth="1.08333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );

  // Reusable - button
  const MinusButton = ({ id }) => (
    <Button
      size="small"
      onClick={() => removeRow(id)}
      style={{
        borderRadius: 8,
        color: '#628478',
        backgroundColor: '#F4F8F7',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.70837 6.5H10.2917"
          stroke="#628478"
          strokeWidth="1.08333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ display: 'flex', gap: 10 }}>
          {!isEditingCourses ? (
            <Button
              icon={<EditPenIcon />}
              onClick={() => setIsEditingCourses(true)}
            />
          ) : (
            <>
              <Button
                style={{ borderRadius: 10 }}
                onClick={() => setIsEditingCourses(false)}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                onClick={handleSaveClick}
                style={{
                  backgroundColor: '#1B392F',
                  borderColor: '#1F4D3D',
                  borderRadius: 10,
                }}
              >
                Speichern
              </Button>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          backgroundColor: 'white',
          width: '100%',
          paddingBottom: 20,
          borderBottom: isLast ? 'none' : '1px solid #E5E5E5',
          marginBottom: isLast ? 0 : 20,
        }}
        className="dropdown-style-change"
      >
        <Form
          form={form}
          onFinish={updateCourse}
          hideRequiredMark
          initialValues={{
            courseValues: course,
          }}
        >
          <fieldset
            disabled={!isEditingCourses}
            style={{ border: 'none', padding: 0 }}
          >
            <Row>
              <Col
                span={18}
                className="standardCol"
                style={{ marginRight: 20 }}
              >
                <Row gutter={18}>
                  <Col span={9}>
                    <div>
                      <h5 style={{ fontSize: 14 }}>Name des Platzes</h5>
                      <Form.Item name={['courseValues', 0, 'name']}>
                        <Input size="small" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div>
                      <h5 style={{ fontSize: 14 }}>Platzgröße</h5>
                      <Form.Item name={['courseValues', 0, 'holes']}>
                        <Select size="small" className="ctm-selector">
                          <Option value={27}>27</Option>
                          <Option value={18}>18</Option>
                          <Option value={9}>9</Option>
                          <Option value={6}>6</Option>
                          <Option value={5}>5</Option>
                          <Option value={4}>4</Option>
                          <Option value={3}>3</Option>
                        </Select>
                        {/* <Input size="small" /> */}
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col span={24} className="standardCol">
                {/* Header Row */}
                <Row style={{ marginTop: 15, gap: 9 }}>
                  <Col flex={'150px'} className="pricingCol">
                    <h6 style={{ color: '#222222' }}>Greenfee für ...</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Montag</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Dienstag</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Mittwoch</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Donnerstag</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Freitag</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Samstag</h6>
                  </Col>
                  <Col flex={'90px'} className="pricingCol">
                    <h6>Sonntag/Feiertage</h6>
                  </Col>
                  <Col flex="40px"></Col>
                </Row>

                {/* Existing pricing rows */}
                {course.map((pricing, index) => {
                  return (
                    <Row
                      key={index}
                      className="pricingRow"
                      style={{ marginTop: 15, gap: 9 }}
                    >
                      <Col
                        flex={'164px'}
                        className="pricingCol"
                        onMouseEnter={(e) =>
                          handleChangeCourseValue(e, pricing, index)
                        }
                        onMouseLeave={handleMouseLeave}
                      >
                        <Form.Item
                          name={[
                            'courseValues',
                            index,
                            'standardPricing',
                            '_id',
                          ]}
                          initialValue={pricing.standardPricing._id}
                          hidden
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name={[
                            'courseValues',
                            index,
                            'standardPricing',
                            'name',
                          ]}
                        >
                          {isCourseValue == pricing.standardPricing._id ? (
                            <Select
                              size="small"
                              defaultValue={`${course[index].standardPricing.numberHoles}-Loch`}
                              onChange={(value) =>
                                handleSelectChange(value, index)
                              }
                            >
                              <Option value={36}>36</Option>
                              <Option value={27}>27</Option>
                              <Option value={18}>18</Option>
                              <Option value={9}>9</Option>
                              <Option value={6}>6</Option>
                              <Option value={3}>3</Option>
                              <Option value="dayfee">Tagesfee</Option>
                            </Select>
                          ) : selectedCourse[index] ? (
                            <span>
                              {selectedCourse[index] === 'dayfee'
                                ? 'Tagesfee'
                                : `${selectedCourse[index]}-Loch`}
                            </span>
                          ) : (
                            <span>
                              {pricing.standardPricing.numberHoles
                                ? `${pricing.standardPricing.numberHoles}-Loch`
                                : 'Tagesfee'}
                            </span>
                          )}
                        </Form.Item>
                      </Col>

                      {[0, 1, 2, 3, 4, 5, 6].map((colIndex) => (
                        <Col
                          key={colIndex}
                          flex={'90px'}
                          className="pricingCol"
                        >
                          <EuroInput
                            namePath={[
                              'courseValues',
                              index,
                              'standardPricing',
                              'prices',
                              colIndex,
                            ]}
                            tabIndex={getTabIndex(index, colIndex)}
                          />
                        </Col>
                      ))}

                      <Col
                        flex="40px"
                        style={{ paddingTop: '5px', textAlign: 'right' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            gap: 6,
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                          }}
                        >
                          {course.length > 1 && (
                            <Popconfirm
                              title="Löschen Sie den Deal"
                              description="Wirklich löschen?"
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: 'red' }}
                                />
                              }
                              onConfirm={() =>
                                deleteStandardPricing(
                                  pricing.standardPricing._id,
                                )
                              }
                              onCancel={cancel}
                              okText="Bestätigen"
                              cancelText="Abbrechen"
                            >
                              <Button
                                danger
                                type="primary"
                                icon={<DeleteFilled />}
                                size="small"
                              />
                            </Popconfirm>
                          )}

                          {/* Show + button on the last existing row only when no new rows exist */}
                          {isEditingCourses &&
                            index === course.length - 1 &&
                            newRows.length === 0 && <PlusButton />}
                        </div>
                      </Col>
                    </Row>
                  );
                })}

                {/* Dynamic new pricing rows */}
                {newRows.map((row, rowIndex) => (
                  <Row
                    key={row.id}
                    className="pricingRow"
                    style={{ marginBlock: 15, gap: 9 }}
                  >
                    <Col flex={'164px'} className="pricingCol">
                      <Form.Item name={['newPricing', rowIndex, 'holes']}>
                        <Select size="small">
                          <Option value={36}>36</Option>
                          <Option value={27}>27</Option>
                          <Option value={18}>18</Option>
                          <Option value={9}>9</Option>
                          <Option value={6}>6</Option>
                          <Option value={3}>3</Option>
                          <Option value="dayfee">Tagesfee</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    {[0, 1, 2, 3, 4, 5, 6].map((colIndex) => (
                      <Col key={colIndex} flex={'90px'} className="pricingCol">
                        <EuroInput
                          namePath={[
                            'newPricing',
                            rowIndex,
                            'prices',
                            colIndex,
                          ]}
                          tabIndex={
                            newPricingStartIndex +
                            rowIndex * TAB_COLUMNS +
                            colIndex
                          }
                        />
                      </Col>
                    ))}

                    <Col flex="40px">
                      <div
                        style={{
                          display: 'flex',
                          gap: 6,
                          alignItems: 'end',
                          height: '100%',
                        }}
                      >
                        {/* Minus always visible on every dynamic row */}
                        <MinusButton id={row.id} />

                        {/* Plus only on the last dynamic row */}
                        {rowIndex === newRows.length - 1 && <PlusButton />}
                      </div>
                    </Col>
                  </Row>
                ))}

                {/* Standalone + button shown only when no new rows exist */}

                <Row
                  style={{ width: '100%', paddingRight: 0, paddingBottom: 0 }}
                  justify="end"
                />
              </Col>
            </Row>
          </fieldset>
        </Form>
      </div>
    </>
  );
});

export default EditCoursesComponent;
